var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormSections',{attrs:{"config":_vm.configValues,"vuelidate":_vm.$v,"custom-allowed":true},on:{"updated":_vm.previewConfig,"delete-field":_vm.deleteField}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }